import { useSubmitJustificativaVisualizarProntuario } from '../useSubmitJustificativaVisualizarProntuario'
import { JustificativaFormModel, JustificativaModal } from './JustificativaModal'

interface JustificativaModalProps {
  cidadaoId: ID
  prontuarioId: ID
  isModalOpen: boolean
  onReject?(): void
  onConfirm?(justificativaId: ID): void
}

export const JustificativaVisualizarProntuarioModal = (props: JustificativaModalProps) => {
  const { cidadaoId, prontuarioId, isModalOpen, onConfirm, onReject } = props

  const { submitJustificativa, clearJustificativa } = useSubmitJustificativaVisualizarProntuario(cidadaoId)

  const handleConfirm = async (values: JustificativaFormModel) => {
    const justificativaId = await submitJustificativa(prontuarioId, values)
    if (justificativaId) {
      onConfirm?.(justificativaId)
    }
  }

  const handleCancel = () => {
    clearJustificativa()
    onReject?.()
  }

  return (
    <JustificativaModal
      heading='Justificativa para visualizar prontuário:'
      text='Informe uma justificativa para visualizar o prontuário:'
      isModalOpen={isModalOpen}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      onReject={onReject}
    />
  )
}
